module.exports = "<span [ngClass]=\"[ info, float == '' ? 'float' : '' ]\">{{setValue(info)}}</span>"